var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.767 28.5342V28.5335H31.7708V22.6832C31.7708 19.8211 31.1908 17.6165 28.0412 17.6165C26.5271 17.6165 25.511 18.4991 25.0962 19.3359H25.0524V17.8836H22.0661V28.5335H25.1757V23.2601C25.1757 21.8716 25.4234 20.529 27.042 20.529C28.6368 20.529 28.6606 22.1136 28.6606 23.3492V28.5342H31.767Z",
    fill: "#626975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 18.2368H19.5103V28.7675H16.0001V18.2368Z",
    fill: "#626975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8197 12.7676C16.8152 12.7676 16.0001 13.5789 16.0001 14.5787C16.0001 15.5785 16.8152 16.4068 17.8197 16.4068C18.8242 16.4068 19.6393 15.5785 19.6393 14.5787C19.6387 13.5789 18.8236 12.7676 17.8197 12.7676V12.7676Z",
    fill: "#626975"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 3.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_362",
    x: 0.763637,
    y: 0.381818,
    width: 46.4727,
    height: 46.4727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.705882 0 0 0 0 0.72549 0 0 0 0 0.780392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_362",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.691871c4.svg";
export { ForwardRef as ReactComponent };